// LegalShield Associate Links Configuration
// Update these URLs to change where all buttons across the site point to

export const LEGALSHIELD_LINKS = {
  // Personal/Family Legal Plan
  PERSONAL_PLAN_URL: 'https://matttheriault.legalshieldassociate.com/legal',
  
  // Landlord/Side-Hustle (Personal Plan + Home Business Supplement)
  LANDLORD_SUPPLEMENT_URL: 'https://matttheriault.legalshieldassociate.com/legal',
  
  // Small Business Plan
  BUSINESS_PLAN_URL: 'https://matttheriault.legalshieldassociate.com/smb',
  
  // IDShield Identity Protection
  IDENTITY_PLAN_URL: 'https://matttheriault.legalshieldassociate.com/identity',
  
  // Commercial Driver / CDL Protection (optional)
  CDL_PLAN_URL: 'https://matttheriault.legalshieldassociate.com/commercial-driver',
};

// Helper function to get a specific link
export function getLegalShieldLink(key: keyof typeof LEGALSHIELD_LINKS): string {
  return LEGALSHIELD_LINKS[key];
}
